import { NgModule } from '@angular/core';
import { MatSelectModule } from '@angular/material/select';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { StatusComponent } from './status.component';

@NgModule({
    entryComponents: [
        StatusComponent
    ],
    declarations: [
        StatusComponent
    ],
    imports: [
        TranslateModule,
        FuseSharedModule,

        MatSelectModule
    ],
    exports: [
        StatusComponent
    ]
})
export class StatusModule {}
